<ng-container *transloco="let t; read: 'inbox-page'">
  <p-messages severity="info">
    <ng-template pTemplate>
      <p class="wrap">{{ t('description') }}</p>
    </ng-template>
  </p-messages>
  <app-inbox-table></app-inbox-table>
</ng-container>
